import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { dashboardActions } from '..';
import { rangeActions } from '../actions';
import { IState } from '../states';

@Injectable()
export class RangeEffects {
  constructor(
    private _actions$: Actions,
    private _dashboardStore: Store<IState>,
  ) {}

  onResetDateValues$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(rangeActions.resetRangeValues),
        tap(({ shopId }) => this._dashboardStore.dispatch(dashboardActions.loadDashboardData({ shopId }))),
      ),
    {
      dispatch: false,
    },
  );

  onSetDateValue$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(rangeActions.setEndDateValue),
        tap(({ shopId }) => {
          return this._dashboardStore.dispatch(dashboardActions.loadDashboardData({ shopId }));
        }),
      ),
    {
      dispatch: false,
    },
  );
}
